import React from 'react';
import { Box } from '@amzn/awsui-components-core';
import pluralize from 'pluralize';

const CharacterCountMessage = ({ input }: { input: string }) => (
  <Box variant="p" color="text-body-secondary" fontSize="body-s" textAlign="right">
    {pluralize('character', input.length, true)}
  </Box>
);

export default CharacterCountMessage;
